import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Register from './components/register';
import Login from './components/login';
import RecoverPassword from './components/RecoverPassword';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Dashboard from './layout/dashboard';
import Chat from './layout/chat';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ChatProvider } from './context/ChatContext';
import Report from './layout/report';
import ResetPassword from './components/ResetPassword';
import Administration from './layout/administration';

/**
 * Componente que decide redirección raíz según autenticación
 */
const AuthWrapper = () => {
    const { auth, initializing } = useContext(AuthContext);
    if (initializing) return <p role="status">Cargando sesión…</p>;
    console.log("🔍 AuthWrapper -> auth:", auth);
    if (auth) {
        console.log("➡️ Redirigiendo a /dashboard");
        return <Navigate to="/dashboard" />;
    } else {
        console.log("➡️ Redirigiendo a /login");
        return <Navigate to="/login" />;
    }
};

/**
 * Rutas privadas
 */
const PrivateRoute = ({ element }) => {
    const { auth, initializing } = useContext(AuthContext);
    if (initializing) return <p role="status">Cargando sesión…</p>;
    return auth ? element : <Navigate to="/login" replace />;
};

/**
 * Rutas públicas
 */
const PublicRoute = ({ element }) => {
    const { auth, initializing } = useContext(AuthContext);
    if (initializing) return <p role="status">Cargando sesión…</p>;
    return !auth ? element : <Navigate to="/dashboard" replace />;
};

/**
 * App principal con estructura de rutas
 */
function App() {
    return (
        <AuthProvider>
            <ChatProvider>
                <Router>
                    <Routes>
                        {/* Rutas públicas */}
                        <Route path="/login" element={<PublicRoute element={<Login />} />} />
                        <Route path="/register" element={<PublicRoute element={<Register />} />} />
                        <Route path="/recover" element={<PublicRoute element={<RecoverPassword />} />} />
                        <Route path="/reset-password" element={<PublicRoute element={<ResetPassword />} />} />

                        {/* Rutas privadas */}
                        <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
                        <Route path="/chat" element={<PrivateRoute element={<Chat />} />} />
                        <Route path="/report" element={<PrivateRoute element={<Report />} />} />
                        <Route path="/administracion" element={<PrivateRoute element={<Administration />} />} />

                        {/* Ruta raíz y fallback */}
                        <Route path="/" element={<AuthWrapper />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Router>
            </ChatProvider>
        </AuthProvider>
    );
}

export default App;
